import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ICategoriaServico } from '../model/categoria_servico.model';

@Injectable()
export class CategoriaServicoService extends EntityService<ICategoriaServico> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'categoria_servico'
      }
    );
  }
}
